import { RequireUser, RequireUserInterface } from '@project44/ui-utils';

import { FeatureFlagsProvider } from '../FeatureFlagsProvider';

export const RequireUserAndFlags = ({
  loadingComponent,
  errorComponent,
  children,
  userIsAuthorized,
}: RequireUserInterface) => (
  <RequireUser
    loadingComponent={loadingComponent}
    errorComponent={errorComponent}
    userIsAuthorized={userIsAuthorized}
  >
    <FeatureFlagsProvider loadingComponent={loadingComponent}>
      {children}
    </FeatureFlagsProvider>
  </RequireUser>
);
